/**
 * 全局配置文件
 */

const API_PORT = process.env.FRONTEND_API_PORT || 8075; // 默认值为8075

module.exports =  {
  title: "能源生态",
  logo: "B",
  advertisement:'：）    禁止分享账号密码给非业务相关人员使用，空闲账户24h联系网站管理员注销，因以上原因造成的数据安全事件，蜂巢能源不承担法律责任',
  key: 'saber',//配置主键,目前用于存储
  clientId: 'ess_auth_client', // 客户端id
  clientSecret: 'ess_auth_secret', // 客户端密钥
  responsetType:'code',
  scope:'all',
  grantType:'authorization_code',
  lockPage: '/lock',
  tokenTime: 3100,
  tokenHeader: 'Blade-Auth',
  //http的status默认放行列表git
  statusWhiteList: [],
  //后台调用地址
  host:{
    // API_URL:'http://svolt-ess-api-gateway-production.svoltems.cn',
    // WS_URL:'ws://svolt-ess-api-gateway-production.svoltems.cn',
    API_URL:'http://www.svoltems.cn',
    WS_URL:'ws://svolt-ess-api-gateway-production.svoltems.cn',
    API_GATEWAY_URL:'http://svolt-ess-api-gateway-production.svoltems.cn',
    //WS_URL:'$ws://svolt-ess-api-gateway-production.svoltems.cn',
    //API_URL:'$SVOLT_ESS_BACKEND_URL',

    // API_URL:'http://192.168.8.127:10002',
    API_V1:'http://192.168.8.127:9000',
    API_V2:'http://192.168.1.148:9902'
  },
  auth:{
    userKey:'User-Token',
    permissionInfo:'PERMISSION',
    btnPermission:'BUTTON',
    userInfo:'USERINFO',
    routerMap:'ROUTERS',
    ActiveAuth:'ActiveAuth',
    SystemId:'SystemId'
  },
  system:{
    title:'蜂巢能源科技有限公司',
    titleProject:'1MWh钠离子电池光储充智能微网系统'
  }
}



// WEBPACK FOOTER //
// ./src/utils/website.js